import Api from "./Api";

const endpoint = "/notenverwaltung/transfer/mitglieder";
export default {
    get(sv_id, werk_id, noten_id, notentyp) {
        return Api.fetchData(
            endpoint +
                "/sv/" +
                sv_id +
                "/werk/" +
                werk_id +
                "/note/" +
                noten_id +
                "/notentyp/" +
                notentyp
        );
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    deleteTransaction(id) {
        return Api.deleteData(endpoint + "/" + id);
    },
    getSubscriptionList(sv_id, werk_id, noten_id, notentyp) {
        return Api.fetchData(
            endpoint +
                "/sv/" +
                sv_id +
                "/werk/" +
                werk_id +
                "/note/" +
                noten_id +
                "/notentyp/" +
                notentyp +
                "/list/issues"
        );
    },
    getReturnList(sv_id, werk_id, noten_id, notentyp) {
        return Api.fetchData(
            endpoint +
                "/sv/" +
                sv_id +
                "/werk/" +
                werk_id +
                "/note/" +
                noten_id +
                "/notentyp/" +
                notentyp +
                "/list/returns"
        );
    },
    getDuring(sv_id, werk_id, noten_id, notentyp, id = null) {
        var tail = "during";
        if (id) {
            tail += "/" + id;
        }
        return Api.fetchData(
            endpoint +
                "/sv/" +
                sv_id +
                "/werk/" +
                werk_id +
                "/note/" +
                noten_id +
                "/notentyp/" +
                notentyp +
                "/" +
                tail
        );
    },
    getBilling(sv_id, werk_id, noten_id, notentyp, id = null) {
        var tail = "billing";
        if (id) {
            tail += "/" + id;
        }
        return Api.fetchData(
            endpoint +
                "/sv/" +
                sv_id +
                "/werk/" +
                werk_id +
                "/note/" +
                noten_id +
                "/notentyp/" +
                notentyp +
                "/" +
                tail
        );
    }
};
